import { Route, Routes } from 'react-router-dom';
import { ScheduleProvider } from '../src/context/ScheduleContext';
import { Header } from './components/Header';
import { Scheduling } from './pages/Scheduling';
import { GlobalStyle } from './styles/global';
import './styles/tailwind.css';
function App() {
  return (
    <ScheduleProvider>
      <main className="flex flex-col min-h-screen w-full max-w-full bg-gray-50">
        <GlobalStyle />
        <Header />
        <Routes>
          <Route path="/*" element={<Scheduling />} />
        </Routes>
      </main>
    </ScheduleProvider>
  );
}

export default App;
